import React from 'react'
import '../Style/App.css';
import '../Style/Footer.css'

export default function Footer() {
  return (
    <div className='footer'>
      <div>
        <span>CONNECT : FEED</span>
      </div>
      <div>
        <span>© Chen Griner</span>
      </div>
    </div>
  )
}
